import script from "./ShopScopeSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopScopeSelect.vue?vue&type=script&setup=true&lang=js"

import "./ShopScopeSelect.vue?vue&type=style&index=0&id=0eede454&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eede454"]])

export default __exports__